import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import PersonalPageContext from "../../../context/PersonalPageContext/PersonalPageContaxt";
import Breadcrumbs from "../../../layout/breadcrumb";
import { tableId } from "../../../utils/helper";
import TopLoadingBar from "../../../utils/topLoadingBar";
import MultiInquiryShowPopup from "./MultiInquiryShowPopup";
import MultiInquiryPageItem from "./MultiInquiryPageItem";
import { multi_Inquiry_Page } from "../MultipageByteCardBuilder/apis/InquiryApi/InquiryApi";

const MultiInquiryPage = () => {
  const [formvalue, setformValue] = useState([]);
  // const [pageUuid, setPageUuid] = useState("");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [model, setModel] = useState(false);
  const [sortBy, setSortBy] = useState("createdAt");
  const { setRecord, pageSize, page, progress, setProgress } =
    useContext(PersonalPageContext);
  const [careerDeatils, setCareerDeatils] = useState({});

  /**
   * Inquary Page Detils Get FUntion to call and useEffect to use of inquiryPage() function cll and toploading call
   */

  const inquiryPage = async () => {
    const paramObj = {
      pageUuid: localStorage.getItem("pageUuid"),
      pageNumber: page,
      recordsPerPage: pageSize,
      sortOrder,
      sortBy,
      // search: { inquiryType: TYPES.WEB_INQUIRY },
    };
    try {
      const { data } = await multi_Inquiry_Page(paramObj);
      if (data.status === 200) {
        setformValue(data.payload.data);
        setRecord(data.pager.totalRecords);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    inquiryPage();
  }, [page, pageSize, sortOrder, sortBy]);

  useMemo(() => {
    tableId(page, pageSize, formvalue);
  }, [page, pageSize, formvalue]);

  useEffect(() => {
    setProgress(100);
  }, []);

  /**
   * Show Inquary Function Call
   * @param {get inquaryId} inquiryId
   */
  const SHowInquary = (careerInquiry) => {
    setCareerDeatils(careerInquiry);
    setModel(!model);
  };
  return (
    <Fragment>
      <Breadcrumbs parent="Multi Inquiry Page" />
      <TopLoadingBar progress={progress} setProgress={setProgress} />
      <MultiInquiryPageItem
        formvalue={formvalue}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        sortBy={sortBy}
        setSortBy={setSortBy}
        SHowInquary={SHowInquary}
      />
      <MultiInquiryShowPopup
        model={model}
        setModel={setModel}
        detail={careerDeatils}
      />
    </Fragment>
  );
};

export default MultiInquiryPage;
